import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.386719 0.974609L5.44922 6.03711L10.5117 0.974609H0.386719Z", fill: "#F7F7F7" }));
export default SvgArrow;
